import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import ModalPopup from '../../../../common/components/ui/ModalPopup';
import {usePopupReplaceInvoiceContext} from '../../contexts/PopupReplaceInvoiceContext';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import replace from '../../../../common/assets/icons/replace.svg';
import styles from './PopupConfirmReplacement.module.scss';

export type PopupConfirmReplacementProps = {
  invoiceID: string;
  customerEmail: string;
  datetime: string;
}

const PopupConfirmReplacement = ({
                                   invoiceID,
                                   customerEmail,
                                   datetime
                                 }: PopupConfirmReplacementProps) => {
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const handleShowConfirm = () => setShowConfirm(true);
  const handleCloseConfirm = () => setShowConfirm(false);

  const context = useGlobalContext();
  const {
    handleCloseAll,
    handleReplaceInvoice
  } = usePopupReplaceInvoiceContext();

  return (
    <>
      <ButtonAction
        variant={'icon'}
        icon={replace}
        onClick={handleShowConfirm}
        customClassnames={{
          container: styles.button,
          icon: styles.buttonIcon
        }}
      />
      <ModalPopup
        isOpen={showConfirm}
        onRequestClose={() => {
          handleCloseConfirm();
          handleCloseAll();
        }}
        customModalStyles={styles.modal}
      >
        <div dir={context.layoutDirection} className={styles.popupConfirmReplacementContainer}>
          <div className={styles.title}>
            <FormattedMessage
              id={'orderInvoice-modal-invoices-message-are-you-sure-1'}
              defaultMessage={`Please note: Selecting this option will completely cancel the existing invoice {invoiceNum} generated for this customer this month.`}
              values={{invoiceNum: invoiceID}}
            />
          </div>
          <div className={styles.title}>
            <FormattedMessage
              id={'orderInvoice-modal-invoices-message-are-you-sure-2'}
              defaultMessage={`The new invoice you are now entering will be issued in its place.`}
            />
          </div>
          <div className={styles.title}>
            <FormattedMessage
              id={'orderInvoice-modal-invoices-message-are-you-sure-3'}
              defaultMessage={`Should I confirm the cancellation and re-production?`}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <ButtonAction
              variant={'button'}
              label={
                <FormattedMessage
                  id={'orderInvoice-modal-replace-invoice-button-approve'}
                  defaultMessage={'Confirm to cancel and reissue'}
                />
              }
              onClick={async () => {
                handleCloseConfirm();
                await handleReplaceInvoice(invoiceID, customerEmail, datetime);
              }}
              customClassnames={{container: styles.actionButton}}
            />
            <ButtonAction
              variant={'reject'}
              label={
                <FormattedMessage
                  id={'orderInvoice-modal-replace-invoice-button-cancel'}
                  defaultMessage={'Cancel the action and return to the order'}
                />
              }
              onClick={() => {
                handleCloseConfirm();
                handleCloseAll();
              }}
              customClassnames={{container: styles.actionButton}}
            />
          </div>
        </div>
      </ModalPopup>
    </>
  );
};

export default PopupConfirmReplacement;
